export const projectWebsite ={
    lightBg: false,
    date: 'June 2021',
    projectName: 'TessGompper website',
    projectTags: 'Figma, React JS, JS, CSS',
    description: 'To introduce myself to Web Development I designed and developed this site to use as an online portfolio and resume. I protoptyed my site using Figma and created my color palette with Coolors. Before fully diving into this project I introduced myself to HTML, CSS and JavaScript on CodePen by trying different ways to make Navigation bars. Finally, after watching some tutorials, I developed my first responsive website! I plan on updating and improving my site as I learn more about Web Development.',
    imgStart:'row-reverse',
    img: 'images/tess-gompper.svg',
    alt: 'tess-gompper'
};

export const projectShine ={
    lightBg: false,
    date: '06/08/2020',
    projectName: 'Shine',
    projectTags: 'Android Studio, Figma, API, JSON, hackHer',
    description: 'This project was from my first hackathon, hackHer, put on by the Queens Women in Computing group in November of 2020. For this virtual hackathon I worked with 3 other students to create a prototype for an app that would tell users what the best time of each day would be to get outside and enjoy the best weather. Inspired by my own experiences, this app was aimed at students stuck in their dorm all day doing online school who, at the end of the day, woudl come to realize they had not gotten any fresh air or sunshine that day. Using android studio and the Open Weather Map API I programmed the part of the app that calculated which time of day had the best weather based on temperature and weather conditions. This hackathon introduced me to Android Studio, Postman, APIs, and JSON files. Although we did not complete our app as we had hoped, hackHer was a wonderful first hackathon experience that introduced me to lots of new concepts and people from around the world!',
    imgStart:'row-reverse',
    img: 'images/shine.svg',
    alt: 'shine'
};

export const projectOpenWindows ={
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    date: 'July 2021',
    projectName: 'Open Windows vs AC Calculator',
    projectTags: 'Java, Android Studio, JSON',
    description: 'Inspired by my dad, this app uses indoor and outdoor temperatures and humidities to calculate whether you should turn on the air conditioning and close the windows, or turn off the air conditioning and open the windows. For this project I created a simple user interface using Android Studio and programmed all the calculations necessary. In order to get the correct response I converted a spreadsheet of water densities into a JSON file and used a JSONObjectREquest and a URL to access the data. Although the calculations were simple, learning how to read and navigate large JSON files from a URL made this an exciting and challenging project!',
    imgStart:'start',
    img: 'images/open-windows-calc.svg',
    alt: 'open-windows-img'
};

export const project ={
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    date: '00/00/0000',
    projectName: 'project name',
    projectTags: 'tags, tech, tools, skills',
    description: 'project description',
    imgStart:'row reverse',
    img: '',
    alt: 'img'
};